import { CLOSE_CREATE_PERMISSION_MODAL, OPEN_CREATE_PERMISSION_MODAL, OPEN_UPDATE_PERMISSION_MODAL } from "../actions/actionTypes";

const initialState = {
    allPermissions: [],
    error: null,
    isCreatePermissionModalOpen: false,
    selectedPermissionId: null,
  };
  
  const permissionReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ALL_PERMISSIONS_SUCCESS':
            return { ...state, allPermissions: action.payload, error: null };
        case 'CREATE_PERMISSION_SUCCESS':
        case 'UPDATE_PERMISSION_SUCCESS':
            return {
                ...state,
                allPermissions: [ ...state.allPermissions, ...action.payload ],
                error: null,
            };
        case OPEN_CREATE_PERMISSION_MODAL:
            return {...state, isCreatePermissionModalOpen: true}
        case OPEN_UPDATE_PERMISSION_MODAL:
            return {...state, isCreatePermissionModalOpen: true, selectedPermissionId: action.payload}
        case CLOSE_CREATE_PERMISSION_MODAL:
            return {...state, isCreatePermissionModalOpen: false, selectedPermissionId: null}
        case 'ALL_PERMISSIONS_FAILURE':
        case 'CREATE_PERMISSION_FAILURE':
        case 'UPDATE_PERMISSION_FAILURE':
            return { ...state, error: action.payload };
        default:
            return state;
    }
  };
  
  export default permissionReducer;